export default {
  key: 'zh_cn',
  langName: '中文',
  unableSubmit: '*无法提交时请检查其他语种*',
  closeOther: "关闭其他",
  closeAll: "关闭所有",
  yes: "是",
  no: "否",
  search: "搜索",
  choose: "选择 ",
  chooseTenant: "选择房客",
  add: "新增",
  edit: "编辑",
  addItem: "新增项目",
  editItem: "编辑项目",
  delete: "删除",
  submit: "提交",
  cancel: "取消",
  prompt: "提示",
  enabled: "启用",
  disable: "禁用",
  pleaseEnter: "请输入",
  pleaseChoose: "请选择",
  success: "成功",
  operation: "操作",
  download: "下载",
  save: "保存",
  deletePrompt: "确认删除该记录吗?",
  deleteAllPrompt: "确认删除全部吗?",
  deleteSuccess: "删除成功",
  selectRow: "请选择一行数据！",
  submitPrompt: "确认提交吗?",
  uploadImgLabel: "上传图片",
  uploadFileLabel: "上传文件",
  uploadtipStart: "只能上传",
  uploadtipEnd: "文件，且不超过2MB",
  uploadClick: "点击上传",
  deleteImgPrompt: "确定删除吗？删除后不可恢复.",
  pleaseUpload: "请上传文件!",
  recoverImgPrompt: "设置为封面吗？",
  balance: "余额",
  EnterContent: "请输入...",
  EnterAmount: "请输入金额",
  Number: "号码",
  Address: "地址",
  Fies: "文件",
  System: "系统",
  Cover: "封面",
  ShareCover: "分享封面",
  Name: "名称",
  Phone: "电话",
  Remark: "备注",
  ZipCode: "邮编",
  Enabled: "状态",
  Created: "创建时间",
  CreatedName: "创建人",
  ModifiedName: "修改人",
  Modified: "修改时间",
  Model: "模式",
  TypeName: "类型",
  AreaName: "区划",
  Mobile: "手机号码",
  Contract: "合约",
  Status: "状态",
  Payment: "付款",
  PaymentTerm: "付款方式",
  Amount: "金额",
  PaymentAmount: "付款金额",
  Active: "活跃",
  ActualAmount: "实付金额",
  DateTime: "时间",
  StartDateTime: "开始时间",
  EndDateTime: "结束时间",
  Operation: "操作",
  Detailed: "详细",
  Occupation: "职业",
  Gender: "性别",
  PassType: "证件类型",
  SelectEstate: "选择社区",
  Approver: "审核人",
  Value: "值",
  AllType: "全部类型",
  Day: "天",
  BasicInfo: "基础信息",
  PrevSteps: "上一步",
  NextSteps: "下一步",
  Cellphone: "联系电话",
  uploadImgLabel: "上传图片",
  uploadChoose: "重新选择",
  Price: "价格",
  Reco: "推荐",
  Spec: "规格",
  Items: "项目",
  Hot: "热门",
  Introduce: "介绍",
  LowestNumber: "最小量",
  MaxNumber: "最大量",
  Sort: "排序",
  ZeroChoose: "请选择信息",
  Timeframe: "时间段",
  Total: "合计",
  SearchProduct: "查找产品",
  Week: "星期",
  Mode: "模式",
  PayMode: "支付方式",
  GenderList: {
    1: '男',
    2: '女'
  },
  admininfo: {
    settings: "设置",
    outlogin: "退出登录"
  },
  Roles: {
    Name: "角色名",
    Description: "说明",
  },
  AdminUser: {
    NickName: "昵称",
    LoginName: "登录名",
    RoleName: "角色",
    Password: "密码",
    ResetPass: "确认重置密码为000000吗？",
  },
  Module: {
    LinkUrl: "接口地址",
    Name: "接口描述",
  },
  Permission: {
    Name: "菜单/按钮",
    Code: "路由地址",
    MName: "API接口",
    IsButton: "是否按钮",
    IsHide: "是否隐藏",
    Description: "描述",
    Func: "按钮事件",
    PidArr: "父级菜单"
  },
  Notification: {
    Title: "标题",
    Content: "内容",
    Send: "发送",
    SendCount: "发送次数",
    SendConfirm: "您确定发送吗？",
    TypeList: {
      1: "房主",
      2: "房客"
    },
    ModelList: {
      1: "全体",
      2: "个人"
    },
  },
  Shop: {
    Name: "门店名称",
    OrderNumber: "订单量",
    LowestPrice: "起送金额",
    FreightDerate: "运费减免比例%",
    PostageInfo: "邮费说明",
    ShareLink: "链接",
    WxOpenUrl: "小程序链接",
    DelayDay: "延迟配送",
    ClearingTime: "结算时间",
    Area: "商户区域",
    Distance: "自送配送距离",
    DeliveryModel: "配送方式",
    Intro: "简介",
    ListIntro: "列表简介",
    DeliveryModelList: {
      1: "自送距离模式",
      2: "车队距离配送",
      3: "固定配送",
      4: "混合配送"
    },
  },
  Product: {
    Type: "产品分类",
    ItemQTY: "可选数量"
  },
  HistoryFolder: {
    TypeList: {
      1: "公开",
      2: "私人"
    },
    HistoryData: "数据管理",
    UploadData: "导入数据"
  },
  Order: {
    OrderNo: "订单号",
    Freight: "运费",
    payImage: "转账截图",
    SubmitTime: "提交时间",
    EditStatus: "修改状态",
    EditAllStatus: "批量修改状态",
    ShippingDate: "配送日期",
    UpdateTotal: "更新合计",
    LimitMode: "限购方式",
    selStatusList: {
      0: "全部状态",
      101: "等待付款",
      102: "等待商家接单",
      201: "已确认待送达",
      202: "等待骑手接单",
      203: "骑手已接单",
      204: "骑手派送中",
      300: "配送完成",
      401: "订单取消",
      402: "申请退款",
      403: "已退款",
    },
    StatusList: {
      101: "等待付款",
      102: "等待商家接单",
      201: "已确认待送达",
      202: "等待骑手接单",
      203: "骑手已接单",
      204: "骑手派送中",
      300: "配送完成",
      401: "订单取消",
      402: "申请退款",
      403: "已退款",
    },
    LimitModeList: {
      1: "每单",
      2: "每天",
      3: "每人"
    },
    ModeList: {
      1: "商城",
      2: "餐饮"
    },
    PayType: {
      1: "PayNow",
      2: "银行转账",
      3: "微信支付",
      4: "其他支付"
    }
  },
  Express: {
    StatusList: {
      1: "等待安排骑手",
      2: "骑手已接单",
      3: "取消",
      4: "已取货",
      5: "拒绝",
      6: "完成",
      7: "过期",
    },
  },
  CashFlowType: {
    1: "订单收入",
    2: "运费收入",
    3: "管理费支出",
    4: "配送支出",
    5: "退款支出",
    6: "拼单返利",
    7: "提现",
    8: "GST",
    9: "管理费返还"
  },
  Transaction: {
    Type: {
      1: "拼单支付",
      2: "超时未支付退款",
      3: "订单退款",
      4: "红包",
      5: "储值",
      6: "返利"
    }
  },
  TourDiy: {
    StatusList: {
      1: "进行中",
      2: "已结束"
    },
    SendStatusList: {
      1: "未发奖",
      2: "已发送"
    },
    ShopStatusList: {
      1: "等待确认",
      2: "商家已确认",
      3: "已完成"
    },
  },
  Recharge: {
    StatusList: {
      1: "等待付款",
      2: "等待审核",
      3: "审核失败",
      4: "已完成",
      5: "已取消",
    },
  },
  ShopDateEvent: {
    ModeList: {
      1: "全体",
      2: "商户"
    },
    TypeList: {
      1: "暂停销售",
      2: "订单备注",
      3: "增加服务费"
    }
  },
  ShopPayoutStatus: {
    1: "审核中",
    2: "已通过",
    3: "已取消",
    4: "驳回",
  }
}